let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hsq9S")).then(() => parcelRequire('8MiMS'));